import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function CalamityTraing_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('CalamityData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/operrslt/areaCalamityTraingRsltDetail.do', {
                params: sendData
            });
            setData(response.data);
            console.log(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };
    const [searchParams, setSearchParams] = useState({
        iemId: '',
        detailSn: '',
        actAreaTyCd: '', //구분
        opmtDt: '',//개최일자
        emtInsttCd: '', //기관명
        edcTrget: '',
        edcPlace: '',
        dcCn: '',//주요내용
        etcRm: '', //비고
        atndncRt: '',//참석자 수 
    });

    const isUpdate = sendData.flag === 'update';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: 'Y',
                        loca: ''
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            iemId: sendData.IEM_ID,
            detailSn: sendData.DETAIL_SN || null,
            actAreaTyCd: data.ACT_AREA_TY_CD, //구분
            opmtDt: isUpdate ? data.TR_OPMT_DT : sendData.TR_OPMT_DT,//개최일자
            emtInsttCd: data.EMT_INSTT_CD, //기관명
            edcTrget: data.EDC_TRGET,
            edcPlace: data.EDC_PLACE,
            dcCn: data.DC_CN,//주요내용
            etcRm: data.ETC_RM, //비고
            atndncRt: data.ATNDNC_RT,//참석자 수
        }));
        setAtchDta(data.ATCH_DTA);
    }, [data]);

    const del = async () => {
        const confirmMessage = "정말로 삭제하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        try {
            const response = await axios.get("/trmsapi/operrslt/areaCalamityTraingRsltDetailDelete.do", {
                params: sendData.DETAIL_SN,
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    };

    const save = async () => {
        const requiredFields = [
            { key: 'actAreaTyCd', label: '구분' },
            { key: 'emtInsttCd', label: '기관명' },
            { key: 'opmtDt', label: '개최일자' },
            { key: 'edcTrget', label: '대상' },
            { key: 'edcPlace', label: '장소' },
            { key: 'dcCn', label: '안건(주요내용)' },
            { key: 'atndncRt', label: '참석자 수' },
        ];

        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
            if (['atndncRt'].includes(field.key)) {
                const numValue = Number(value);
                if (numValue < 0) {
                    alert(`${field.label}에 입력할 수 없는 값입니다.`);
                    return;
                }
            }
        }

        const confirmMessage = "저장하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) return;
        const formData = new FormData();
        // searchParams 값들 추가
        Object.entries(searchParams).forEach(([key, value]) => {
            formData.append(key, value);
        });
        // 파일 추가
        if (atchDta) {
            formData.append("atchNm", atchDta); // File 객체
        }

        // 유저 ID 추가
        formData.append("userId", localStorage.getItem("id"));


        try {
            const response = await axios.post(
                "/trmsapi/operrslt/areaCalamityTraingRsltDetailSave.do",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            alert(response.data.resultMessage);
        } catch (error) {
            console.error("데이터 저장 중 오류 발생:", error);
        }
    };

    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>지역 내 재난 훈련</h5>
                <div className='flex gap-1'>
                    {isUpdate && (
                        <button onClick={del} title="삭제" className='search_btn bg_co_black justify-self-end'>
                            <Icons.DeleteCircle16w />삭제
                        </button>
                    )}
                    <button onClick={save} title={isUpdate ? '수정' : '저장'} className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{isUpdate ? '수정' : '저장'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="20%" />
                            <col width="30%" />
                            <col width="20%" />
                            <col width="30%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>구분</th>
                                <td>
                                    <select
                                        id="actAreaTyCd"
                                        name="actAreaTyCd"
                                        className='w-full'
                                        value={searchParams.actAreaTyCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        <option value="AR01">대내</option>
                                        <option value="AR02">대외</option>
                                        <option value="AR03">대/내외</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>개최일자</th>
                                <td>
                                    <input
                                        type="date"
                                        name="opmtDt"
                                        id="opmtDt"
                                        value={searchParams.opmtDt}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>기관명</th>
                                <td>
                                    <select
                                        name="emtInsttCd"
                                        id="emtInsttCd"
                                        className='w-full'
                                        value={searchParams.emtInsttCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        {emogList.map((hosp) => (
                                            <option key={hosp.emogcode} value={hosp.emogcode}>
                                                {hosp.emogdesc}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>대상</th>
                                <td colSpan="3">
                                    <textarea
                                        id="edcTrget"
                                        name="edcTrget"
                                        rows="1"
                                        className='textarea_style'
                                        value={searchParams.edcTrget}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>장소</th>
                                <td colSpan="3">
                                    <textarea
                                        id="edcPlace"
                                        name="edcPlace"
                                        rows="1"
                                        className='textarea_style'
                                        value={searchParams.edcPlace}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>안건(주요내용)</th>
                                <td colSpan="3">
                                    <textarea
                                        id="dcCn"
                                        name="dcCn"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.dcCn}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan="3">
                                    <textarea
                                        id="etcRm"
                                        name="etcRm"
                                        rows="3"
                                        className='textarea_style'
                                        value={searchParams.etcRm}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>참석자 수</th>
                                <td colSpan={3}>
                                    <input
                                        type='number'
                                        id='atndncRt'
                                        name='atndncRt'
                                        className='input_style'
                                        onChange={handleChange}
                                        value={searchParams.atndncRt}
                                    />
                                </td>
                            </tr>
                            {isUpdate && (
                                <tr>
                                    <th>생성일</th>
                                    <td>{data.TR_CREAT_DT}</td>
                                    <th>수정일</th>
                                    <td>{data.TR_UPDT_DT || ''}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}
export default CalamityTraing_popup;
